import isEmpty from 'lodash/isEmpty';

import { QUESTION_TYPES } from '../../../constants/props';

export const getFlatQuestionsWithPosition = (data, withPosition = true) => {
  const flatQuestions = [];

  const makeFlatQuestions = (arr, levelIteration, indexBlock) => {
    let nestedNumber = 0;
    let number = 0;
    return arr.forEach((item, iteration) => {
      const hasNestedQuestions = !isEmpty(item.questions);
      const fieldType = item.settings.name;
      nestedNumber += Number(fieldType !== QUESTION_TYPES.comment);
      number += Number(fieldType !== QUESTION_TYPES.comment);
      flatQuestions.push({
        indexBlock: indexBlock || iteration + 1,
        ...(withPosition && {
          viewPosition: levelIteration
            ? `${levelIteration}${nestedNumber}`
            : `${number}.`,
        }),
        ...item,
      });
      if (hasNestedQuestions) {
        makeFlatQuestions(
          item.questions,
          levelIteration ? `${levelIteration}${nestedNumber}.` : `${number}.`,
          indexBlock || iteration + 1,
        );
      }
    });
  };

  makeFlatQuestions(data, false);

  return flatQuestions;
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getFlatQuestionsWithPosition.js